import { Component, OnInit } from '@angular/core';
import { AuthService } from './login-service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'admin-showitbig';

  constructor(private authService: AuthService) {

  }

  ngOnInit() {
    // this.authService.login();
  }

  logout() {
    this.authService.logout();
  }
}
